import React from "react";
import { API_URL } from "src/Common/function";
import UserService from "src/Services/API/user.service";

// Tutorial files live in the tenant's public folder on the backend
// (public/<company>/tutorials/browser/), so the list is built from the
// logged-in user's company — nothing is hardcoded to a specific tenant.
const buildUserGuideData = (company) => {
  const base = `${API_URL}/${company}/tutorials/browser`;
  const thumbnail = `${base}/thumbnail.png`;
  return [
    {
      title: "CREATING A WO TUTORIAL V2",
      url: `${base}/BROWSER - CREATING A WO TUTORIAL V2.mp4`,
      thumbnail,
    },
    {
      title: "HOW TO EDIT A SERVICE TICKET V1",
      url: `${base}/BROWSER - HOW TO EDIT A SERVICE TICKET V1.mp4`,
      thumbnail,
    },
    {
      title: "HOW TO EDIT A WO TUTORIAL V1",
      url: `${base}/BROWSER - HOW TO EDIT A WO TUTORIAL V1.mp4`,
      thumbnail,
    },
    {
      title: "HOW TO EDIT A WO TUTORIAL V2",
      url: `${base}/BROWSER - HOW TO EDIT A WO TUTORIAL V2.mp4`,
      thumbnail,
    },
    {
      title: "HOW TO GET REPORTS V2",
      url: `${base}/BROWSER - HOW TO GET REPORTS V2.mp4`,
      thumbnail,
    },
  ];
};

const UserGuideItem = ({ guide }) => {
  const thumbnailSrc = guide.thumbnail || "/images/sidemenu/help/thumbnail.png";
  return (
    <a
      href={guide.url}
      target="_blank"
      rel="noreferrer"
      className="flex flex-col gap-3"
    >
      <div className="aspect-video w-full overflow-hidden rounded-md border border-[#d8dbe6] bg-[#e9ecf5]">
        <img
          src={thumbnailSrc}
          alt={guide.title}
          loading="lazy"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="flex flex-col gap-1">
        <div className="text-[15px] font-semibold text-[#1b1f3b]">{guide.title}</div>
      </div>
    </a>
  );
};

const UserGuides = () => {
  const user = UserService.getCurrentUser();
  const userGuideData = buildUserGuideData(user?.company);
  return (
    <div className="flex flex-col gap-6 p-6">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {userGuideData.map((guide) => (
          <UserGuideItem key={guide.title} guide={guide} />
        ))}
      </div>
    </div>
  );
};

export default UserGuides;